import { ConfirmationModal } from "components/modal/ConfirmationModal";
import { useGetMspById, useGlobalStore } from "controller";
import React, { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useMixpanelPageViewTracker } from "utilz/helpers";
import { NoSubscriptionScreen, SubscriptionDetails } from "./components";
import {
  CancelledSubscriptionBanner,
  PricingPageFrame,
} from "./components/pricing";
import { OverviewPricing } from "./components/subscription-details/OverviewPricing";

export const SubscriptionHomeScreen = () => {
  useMixpanelPageViewTracker({ event: "subscription_page_visited" });
  const [searchParams, setSearchParams] = useSearchParams();
  const resourceId = useGlobalStore((state) => state.resourceId);
  const { data: mspData } = useGetMspById(resourceId || "");
  const [modalType, setModalType] = React.useState<
    "success" | "error" | "update" | null
  >(null);

  useEffect(() => {
    if (searchParams.get("type")) {
      setModalType(searchParams.get("type") as "success" | "error" | "update");
    }
  }, []);

  const handleClose = () => {
    setModalType(null);
    searchParams.delete("type");
    setSearchParams(searchParams);
  };

  const checkSubscriptionStatus = () => {
    if (mspData?.status === "active" || mspData?.status === "past_due") {
      if (mspData?.cancel_at_period_end === true) {
        return false;
      }
      return true;
    }
    return false;
  };
  if (!mspData) return <></>;
  return (
    <div style={{ height: "100%" }}>
      {checkSubscriptionStatus() ? (
        <SubscriptionDetails />
      ) : (
        // <NoSubscriptionScreen />
        <NotSubscribedScreen />
      )}

      {modalType && (
        <ConfirmationModal
          title={getConfirmationTitle(modalType)}
          open={modalType ? true : false}
          type={modalType}
          tagline={getConfirmationTagline(modalType)}
          hideSecondaryButton
          primaryButtonText="Close"
          onPrimaryButtonClick={handleClose}
        />
      )}
    </div>
  );
};

const getConfirmationTitle = (type: "success" | "error" | "update") => {
  switch (type) {
    case "success":
      return "Payment successful";
    case "error":
      return "Payment failed";
    case "update":
      return "Seat count updated";

    default:
      return "";
  }
};

const getConfirmationTagline = (type: "success" | "error" | "update") => {
  switch (type) {
    case "success":
      return "Your payment has been processed successfully.";
    case "error":
      return "It looks like there was an issue processing your payment. Please double-check your payment details and give it another shot.";
    case "update":
      return "Your seat count has been changed successfully.";
  }
};

const NotSubscribedScreen = () => {
  const [searchParams, _setSearchParams] = useSearchParams();
  const [isPricingTableDisplayed, setIsPricingTableDisplayed] =
    React.useState(true);

  useEffect(() => {
    if (searchParams.get("package")) {
      setIsPricingTableDisplayed(false);
    } else {
      setIsPricingTableDisplayed(true);
    }
  }, [searchParams]);

  const isSubscriptionCancelled = useGlobalStore(
    (state) => state.cancelAtPeriodEnd,
  );

  return isPricingTableDisplayed ? (
    <>
      {isSubscriptionCancelled && <CancelledSubscriptionBanner />}
      <PricingPageFrame hasBannerAbove={isSubscriptionCancelled === true}>
        <OverviewPricing />
      </PricingPageFrame>
    </>
  ) : (
    <NoSubscriptionScreen />
  );
};
